import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Mic } from "lucide-react";
import { formatTimestamp } from "@/components/meeting/TranscriptTab";

export const TranscriptPreview = ({ transcript, meetingId }) => (
  <Card className="p-8 bg-af-subtle border-af rounded-md" data-testid="transcript-preview">
    <div className="flex items-center justify-between mb-5">
      <div className="flex items-center gap-3">
        <div className="h-9 w-9 rounded-md bg-af-card border border-af flex items-center justify-center">
          <Mic className="h-4 w-4 text-terracotta" />
        </div>
        <div>
          <h3 className="font-display font-bold text-lg">Transcription</h3>
          <p className="text-xs text-af-muted">
            {transcript.segments?.length || 0} segment(s) · {transcript.language?.toUpperCase()}
          </p>
        </div>
      </div>
      <Link to={`/app/meetings/${meetingId}`} className="text-sm text-terracotta hover:underline" data-testid="open-meeting-detail">
        Ouvrir la réunion →
      </Link>
    </div>
    <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2">
      {transcript.segments?.map((seg, i) => (
        <div key={`${seg.start}-${i}`} className="flex gap-4 pb-3 border-b border-af last:border-0">
          <div className="font-mono text-xs text-af-muted w-16 shrink-0 pt-0.5">
            {formatTimestamp(seg.start)}
          </div>
          <div className="flex-1">
            <div className="text-xs font-semibold text-terracotta mb-1">{seg.speaker}</div>
            <div className="text-sm text-af leading-relaxed">{seg.text}</div>
          </div>
        </div>
      ))}
    </div>
  </Card>
);
